// Pure helpers: resolve a property's next visit to (crewId, date) for the
// route-drive lookup. The client-facing mappedRoutes carry { routeId, crewId };
// CrewLeaderContactID is not sent, so we key on routeId only. (Routes are the
// source of truth; we never import the server-only crewIdMap.)
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : null }

export const buildCrewLookupMaps = (routes = []) => {
  const crewByRouteId = new Map()
  for (const r of routes || []) {
    const crewId = r?.crewId ? String(r.crewId) : null
    const rid = num(r?.routeId)
    if (crewId && rid != null && !crewByRouteId.has(rid)) crewByRouteId.set(rid, crewId)
  }
  return { crewByRouteId }
}

export const resolveRouteForDrive = (property = {}, maps = {}) => {
  const visits = (property.futureVisits || [])
    .filter(v => v && v.date)
    .sort((a, b) => new Date(a.date) - new Date(b.date))
  const v = visits[0]
  if (!v) return null
  const crewByRouteId = maps.crewByRouteId || new Map()
  const crewId = crewByRouteId.get(num(v.routeId)) ?? null
  if (!crewId) return null
  return { crewId, date: v.date }
}
